<div class="epi-container" *ngIf="billToID>0||quoteOrderID>0">
    <h4>
        <a [routerLink]="" class="text-white" style="float:right;padding-right:7px;" title="Close" (click)="closeGrid()"><i class="fas fa-minus"></i></a>
        Copy Order
        <!--<button type="button" class="btn btn-secondary m-1" style="float:right" title="Close" (click)="closeGrid()"><i class="fas fa-times"></i></button>-->
    </h4>
    <div class="row">
        <div [ngClass]="(quoteOrderMaster | json) != '{}' ? 'col-sm-8' : 'col-sm-12'">
            <!--<button type="button" class="btn btn-secondary m-1" style="float:right" title="Email" (click)="closeGrid()"><i class="fas fa-times"></i></button>-->
            <kendo-grid #quoteOrderMasterGrid
                        [data]="gridData"
                        [pageSize]="gridState.take"
                        [skip]="gridState.skip"
                        [sort]="gridState.sort"
                        [filter]="gridState.filter"
                        [pageable]="true"
                        [sortable]="true"
                        [filterable]="true"
                        [resizable]="true"
                        [selectable]="true"
                        (detailExpand)="onGridDetailExpand($event)"
                        (detailCollapse)="onGridDetailCollapse($event)"
                        (dataStateChange)="dataStateChange($event)">
                <kendo-grid-column title="Action" width="105">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button (click)="selectQuoteOrderMaster(dataItem)" class="btn btn-sml btn-primary m-1" title="Copy" tabindex="-1" *ngIf="(quoteOrderMaster | json) == '{}'"><i class="fas fa-copy"></i></button>
                        <!--<button (click)="delete(dataItem)" class="btn btn-sml btn-danger" title="Delete" tabindex="-1"><i class="fas fa-times"></i></button>-->
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="numOrders" title="Orders"></kendo-grid-column>
                <kendo-grid-column field="quoteOrderID" title="Order #">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/order-entry', dataItem.quoteOrderID]">
                            {{dataItem.quoteOrderID}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="opportunityLaneQuoteOrderID" title="Opp Ln Order #">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/order-entry', dataItem.opportunityLaneQuoteOrderID]">
                            {{dataItem.opportunityLaneQuoteOrderID}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="quoteOrderTypeDescription" title="Type"></kendo-grid-column>
                <kendo-grid-column field="orderDescription" title="Description">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <!--<textarea rows="{{dataItem.orderDescription != null ? 1+dataItem.orderDescription.length/75 : 1 | number:'1.0-0'}}" cols="75" [(ngModel)]="dataItem.orderDescription"></textarea>-->
                        <!--<i class="fas fa-save fa-2x m-1 text-success" (click)="saveDescription(dataItem)"></i>-->
                        {{ dataItem.orderDescription }}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="shipperName" title="Shipper"></kendo-grid-column>
                <kendo-grid-column field="shipperCity" title="Pick City"></kendo-grid-column>
                <kendo-grid-column field="shipperST" title="Pick ST"></kendo-grid-column>
                <kendo-grid-column field="consigneeName" title="Consignee"></kendo-grid-column>
                <kendo-grid-column field="consigneeCity" title="Drop City"></kendo-grid-column>
                <kendo-grid-column field="consigneeST" title="Drop ST"></kendo-grid-column>
                <kendo-grid-column field="modeAbbrev" title="Mode"></kendo-grid-column>
                <kendo-grid-column field="trailerTypeAbbrev" title="Trailer"></kendo-grid-column>
                <kendo-grid-column field="rateIndexDescription" title="Rate Index"></kendo-grid-column>
                <kendo-grid-column field="isRoundTrip" title="RT">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" [checked]="dataItem.isRoundTrip" style="transform:scale(1.5);margin:10px;" disabled />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="opportunityNotes" title="Opportunity"></kendo-grid-column>
                <div *kendoGridDetailTemplate="let dataItem" style="width:1200px;">
                    <!--[kendoGridDetailTemplateShowIf]="true"-->
                    <kendo-grid #copyLoadGrid
                                [data]="copyLoadGridData"
                                [sort]="copyLoadGridState.sort"
                                [skip]="copyLoadGridState.skip"
                                [pageSize]="copyLoadGridState.take"
                                [sortable]="false"
                                [pageable]="false"
                                [filterable]="false"
                                [resizable]="true">
                        <kendo-grid-column field="legNumber" title="Leg #" [width]="100"></kendo-grid-column>
                        <kendo-grid-column field="ppcCityST" title="PPC City" [width]="150"></kendo-grid-column>
                        <kendo-grid-column field="carrierCode" title="Carrier" [width]="100">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                                    {{dataItem.carrierCode}}
                                </a>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="expirationDate" title="Expiration" [width]="150">
                            <ng-template kendoGridCellTemplate let-load>
                                {{load.expirationDate == '' ? '' : load.expirationDate | date: 'M/dd/yy'}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="isExpired" title="Expired" [width]="100">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <input type="checkbox" [checked]="dataItem.isExpired" style="transform:scale(1.5);margin:10px;" disabled />
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="carrierContactName" title="Contact" [width]="150"></kendo-grid-column>
                        <kendo-grid-column field="driverName" title="Driver" [width]="150"></kendo-grid-column>
                        <kendo-grid-column field="isAutoTender" title="Auto Tender" [width]="100">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <input type="checkbox" [checked]="dataItem.isAutoTender" style="transform:scale(1.5);margin:10px;" disabled />
                            </ng-template>
                        </kendo-grid-column>
                        <!--<kendo-grid-column field="isMacropointRequired" title="MP Req" [width]="100">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <input type="checkbox" [checked]="dataItem.isMacropointRequired" style="transform:scale(1.5);margin:10px;" disabled />
                            </ng-template>
                        </kendo-grid-column>-->
                    </kendo-grid>
                </div>
            </kendo-grid>
        </div>
        <div class="col" *ngIf="(quoteOrderMaster | json) != '{}'">
            <quoteordermaster-form [quoteOrderMaster]="quoteOrderMaster" (onRefresh)="getSearchQuoteOrderMaster()"></quoteordermaster-form>
        </div>
    </div>
    <div class="row" *ngIf="(quoteOrderMaster | json) != '{}'">
        <div class="col-md-12">
            <div class="epi-container">
                <h4>Loads</h4>
                <quoteorderline-grid [quoteOrderID]="quoteOrderMaster.quoteOrderID" [pageType]="'orderentry'" [readonly]="true"></quoteorderline-grid>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="(quoteOrderMaster | json) != '{}'">
        <div class="col-md-12">
            <div class="epi-container">
                <h4>Stops</h4>
                <order-stop-grid [quoteOrderID]="quoteOrderMaster.quoteOrderID" [pageType]="'orderentry'" [pageable]="false"
                                 [pageSize]="'all'" [readonly]="true"></order-stop-grid>
            </div>
        </div>
    </div>
</div>
